export default __webpack_public_path__ + "static/media/index-vision.c108b9f6.png";